<script lang="ts">
  import { Pagination, type PaginationProps } from '@stickerapp-org/athena/Pagination';
  import { HeadingLarge, Paragraph } from '@stickerapp-org/athena/Text';
  import { BuyStickerCard } from '@athena-lib/BuyStickerCard';
  import { Grid } from '@athena-lib/Grid';
  import GridItem from '@athena-lib/Grid/GridItem.svelte';
  import { getLocalizationContext } from '@athena-lib/i18n';
  import { Stack } from '@athena-lib/Stack';
  import StickerShopLayout from './shared/StickerShopLayout.svelte';
  import { getBuyStickerCardProps } from '$lib/utilities/getBuyStickerCardProps';
  import type { TagData } from '$lib/server/external/types';
  import { getShoppingCart } from '$lib/shopping-cart.svelte';
  import { trackCategoryItemViewList } from '$lib/gtm/ecommerce-tracking';
  import { getCheckoutSdk } from '$lib/checkout.svelte';

  const {
    data,
  }: {
    data: TagData;
  } = $props();
  const { figureData, slug, stickerShopMeta, description, descriptiveTitle } = $derived(data);

  const figures = $derived(figureData?.data ?? []);
  const paginationsMeta = $derived(figureData?.meta);
  const showPagination = $derived((paginationsMeta?.total_pages ?? 0) > 1);

  const refreshCart = getShoppingCart().refreshCart;

  let paginationProps: PaginationProps | undefined = $derived(
    stickerShopMeta.stickerShopUrls
      ? {
          pageCount: paginationsMeta?.total_pages ?? 0,
          current: paginationsMeta?.current_page ?? 0,
          baseUrl: `${stickerShopMeta.stickerShopUrls.baseSlug}/${slug}`,
          queryParamName: 'p',
        }
      : undefined,
  );

  const localizationContext = getLocalizationContext();
  const checkoutSdk = $derived(getCheckoutSdk());

  trackCategoryItemViewList({
    figureData: data.figureData,
    stickerShopMeta: data.stickerShopMeta,
    localization: localizationContext,
  });
</script>

<StickerShopLayout>
  <Stack>
    {#if description || descriptiveTitle}
      <div class="py-6">
        {#if descriptiveTitle}
          <HeadingLarge size="medium">{descriptiveTitle}</HeadingLarge>
        {/if}
        {#if description}
          <Paragraph>{description}</Paragraph>
        {/if}
      </div>
    {/if}
    <Grid columns={{ lg: 4, md: 3 }}>
      {#each figures as figure}
        <GridItem>
          <BuyStickerCard
            {...getBuyStickerCardProps(
              figure,
              stickerShopMeta,
              localizationContext,
              refreshCart,
              checkoutSdk,
            )}
          ></BuyStickerCard>
        </GridItem>
      {/each}
    </Grid>

    {#if showPagination && paginationProps}
      <Pagination class="pt-10" {...paginationProps}></Pagination>
    {/if}
  </Stack>
</StickerShopLayout>
